import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

// Context Tienda
import { ProductProvider } from 'src/contexts/ProductosContext';
import { CartProvider } from 'src/contexts/CartContext';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { isLogin, obtenerTipoUsuario } from 'src/auth';

const login = isLogin();
const tipoUsuario = obtenerTipoUsuario();

const Loader = (Component) => (props) =>
    (
        <Suspense fallback={<SuspenseLoader />}>
            <Component {...props} />
        </Suspense>
    );

// Login
const Login = Loader(lazy(() => import('src/content/overview')));

// Login Tienda
const LoginTienda = Loader(lazy(() => import('src/content/login-tienda')));

// Registro
const Registro = Loader(lazy(() => import('src/content/registro')));

// Dashboard
// const Ventas = Loader(lazy(() => import('src/content/dashboards/ventas')));
// const VentasPreventa = Loader(lazy(() => import('src/content/dashboards/ventas_preventas')));
// const Liquidacion = Loader(lazy(() => import('src/content/dashboards/liquidacion')));
// const Inventario = Loader(lazy(() => import('src/content/dashboards/inventario')));
// const Conteo = Loader(lazy(() => import('src/content/dashboards/conteo')));
// const ConteoPreventa = Loader(lazy(() => import('src/content/dashboards/conteo_preventa')));
const Perfil = Loader(lazy(() => import('src/content/dashboards/perfil')));
const Pedidos = Loader(lazy(() => import('src/content/dashboards/pedidos')));
const Usuarios = Loader(lazy(() => import('src/content/dashboards/usuarios')));
const Vendedores = Loader(lazy(() => import('src/content/dashboards/vendedores')));
const Clientes = Loader(lazy(() => import('src/content/dashboards/usuarios-tienda')));
const CategoriasClientes = Loader(lazy(() => import('src/content/dashboards/categorias-clientes')));
const Transactions = Loader(lazy(() => import('src/content/dashboards/productos')));
const BloquePrecios = Loader(lazy(() => import('src/content/dashboards/bloque_precios')));
const ListaPrecios = Loader(lazy(() => import('src/content/dashboards/lista_precios')));
const Promociones = Loader(lazy(() => import('src/content/dashboards/promociones')));
const Banners = Loader(lazy(() => import('src/content/dashboards/banners')));
// const Descuentos = Loader(lazy(() => import('src/content/dashboards/descuentos')));
// const PuntoVenta = Loader(lazy(() => import('src/content/dashboards/puntos_venta')));
// const Rutas = Loader(lazy(() => import('src/content/dashboards/rutas')));
// const RelacionRutaUbicacion = Loader(lazy(() => import('src/content/dashboards/relacion_ruta_ubicacion')));
// const RelacionRutaUbicacionPreventa = Loader(lazy(() => import('src/content/dashboards/relacion_ruta_ubicacion_preventa')));
// const CandadosGps = Loader(lazy(() => import('src/content/dashboards/candados_gps')));
// const Preguntas = Loader(lazy(() => import('src/content/dashboards/preguntas')));
// const VisitaItinerario = Loader(lazy(() => import('src/content/dashboards/visita_itinerario')));

// Tienda Online
const TiendaOnline = Loader(lazy(() => import('src/content/tienda-online')));
const DetallesPedido = Loader(lazy(() => import('src/content/tienda-online/CheckoutDialog')));
const ListaPedidos = Loader(lazy(() => import('src/content/tienda-online/OrderHistory')));
const DetalleProducto = Loader(lazy(() => import('src/content/tienda-online/ProductDetail')));
const ProductosFavoritos = Loader(lazy(() => import('src/content/tienda-online/FavoriteProducts')));

const routes = [
    // LOGIN ADMINISTRADOR
    {
        path: '/administrador',
        element: login && tipoUsuario === "ADMINISTRADOR" 
            ? <Navigate to="/dashboard/pedidos" />
            : login && tipoUsuario === "USUARIO"
                ? <Navigate to="/tienda" />
                : <BaseLayout />,
        children: [
            {
                path: '/administrador',
                element: <Login />
            },
            {
                path: 'overview',
                element: <Navigate to="/administrador" replace />
            },
            {
                path: '*',
                element: <></>
            }
        ]
    },
    // LOGIN USUARIO A TIENDA
    {
        path: '/',
        element: login && tipoUsuario === "ADMINISTRADOR" 
            ? <Navigate to="/dashboard/pedidos" />
            : login && tipoUsuario === "USUARIO"
                ? <Navigate to="/tienda" />
                : <BaseLayout />,
        children: [
            {
                path: '/',
                element: <LoginTienda />
            },
            {
                path: 'overview',
                element: <Navigate to="/" replace />
            },
            {
                path: '*',
                element: <></>
            }
        ]
    },
    // REGISTRO
    {
        path: '/registro',
        element: login && tipoUsuario === "ADMINISTRADOR" 
            ? <Navigate to="/dashboard/pedidos" />
            : login && tipoUsuario === "USUARIO"
                ? <Navigate to="/tienda" />
                : <BaseLayout />,
        children: [
            {
                path: '/registro',
                element: <Registro />
            },
            {
                path: 'overview',
                element: <Navigate to="/" replace />
            },
            {
                path: '*',
                element: <></>
            }
        ]
    },
    {
        path: '/dashboard',
        element: login && tipoUsuario === "ADMINISTRADOR" ? <SidebarLayout /> : <Navigate to="/administrador" />,
        children: [
            {
                path: '',
                element: <Navigate to="pedidos" replace />
            },
            // {
            //     path: 'ventas',
            //     element: <Ventas />
            // },
            // {
            //     path: 'ventas-preventa',
            //     element: <VentasPreventa />
            // },
            // {
            //     path: 'liquidacion',
            //     element: <Liquidacion />
            // },
            // {
            //     path: 'inventario',
            //     element: <Inventario />
            // },
            // {
            //     path: 'conteo',
            //     element: <Conteo />
            // },
            // {
            //     path: 'conteo-preventa',
            //     element: <ConteoPreventa />
            // },
            {
                path: 'perfil',
                element: <Perfil />
            },
            {
                path: 'pedidos',
                element: <Pedidos />
            },
            {
                path: 'usuarios',
                element: <Usuarios />
            },
            {
                path: 'clientes',
                element: <Clientes />
            },
            {
                path: 'vendedores',
                element: <Vendedores />
            },
            {
                path: 'tipos-cliente',
                element: <CategoriasClientes />
            },
            {
                path: 'productos',
                element: <Transactions />
            },
            {
                path: 'bloque-precios',
                element: <BloquePrecios />
            },
            {
                path: 'lista-precios',
                element: <ListaPrecios />
            },
            {
                path: 'promociones',
                element: <Promociones />
            },
            {
                path: 'banners',
                element: <Banners />
            },
            // {
            //     path: 'puntos-venta',
            //     element: <PuntoVenta />
            // },
            // {
            //     path: 'descuentos',
            //     element: <Descuentos />
            // },
            // {
            //     path: 'rutas',
            //     element: <Rutas />
            // },
            // {
            //     path: 'rel_ruta_ubicacion',
            //     element: <RelacionRutaUbicacion />
            // },
            // {
            //     path: 'rel_ruta_ubicacion_preventa',
            //     element: <RelacionRutaUbicacionPreventa />
            // },
            // {
            //     path: 'candados-gps',
            //     element: <CandadosGps />
            // },
            // {
            //     path: 'visita-itinerario',
            //     element: <VisitaItinerario />
            // },
            // {
            //     path: 'preguntas',
            //     element: <Preguntas />
            // }
        ]
    },
    {
        path: '/tienda',
        element: login && tipoUsuario === "USUARIO" ? <ProductProvider><CartProvider><TiendaOnline /></CartProvider></ProductProvider> : <Navigate to="/" />,
    },
    {
        path: '/tienda/detalles-pedido',
        element: login && tipoUsuario === "USUARIO" ? <ProductProvider><CartProvider><DetallesPedido /></CartProvider></ProductProvider> : <Navigate to="/" />,
    },
    {
        path: '/tienda/lista-pedidos',
        element: login && tipoUsuario === "USUARIO" ? <ProductProvider><CartProvider><ListaPedidos /></CartProvider></ProductProvider> : <Navigate to="/" />,
    },
    {
        path: '/tienda/producto/:productId',
        element: login && tipoUsuario === "USUARIO" ? <ProductProvider><CartProvider><DetalleProducto /></CartProvider></ProductProvider> : <Navigate to="/" />,
    },
    {
        path: '/tienda/productos-favoritos',
        element: login && tipoUsuario === "USUARIO" ? <ProductProvider><CartProvider><ProductosFavoritos /></CartProvider></ProductProvider> : <Navigate to="/" />,
    },
];

export default routes;
